/**
 * Undefined rather than a half-built path: the offer may not have resolved a property or vendor yet, and a
 * link missing either id would 404 instead of failing to render.
 */
export function getRoomRateHref({
  propertyId,
  roomRateId,
  roomTypeId,
  vendorId,
}: {
  propertyId?: string;
  roomRateId: string;
  roomTypeId: string;
  vendorId?: string;
}): string | undefined {
  if (!vendorId || !propertyId) {
    return undefined;
  }

  return `/vendors/${vendorId}/properties/${propertyId}/room-types/${roomTypeId}/room-rates/${roomRateId}`;
}
